<template>
  <section class="store-orders py-2" aria-label="營業所郵寄訂單" grid-columns="2fr 2fr repeat(4, 1fr)">
    <div v-if="error" role="alert" class="text-center text-danger py-5"><p>{{ error }}</p><button class="btn btn-outline-success" @click="load(page)">重新載入</button></div>
    <OrderHistoryTable v-else-if="loading || orders.length" :rows="orders" :columns="columns" :loading="loading" :format-cell="formatCell" label="營業所郵寄訂單" grid-columns="2fr 2fr repeat(4, 1fr)">
      <template #order_number="{ row }"><router-link class="font-weight-bold text-success stretched-link" :to="'/member/order/store/' + row.id">{{ row.order_number }}</router-link></template>
    </OrderHistoryTable>
    <p v-else class="text-center text-muted py-5">目前尚無營業所郵寄訂單貨態</p>
    <div v-if="!loading && !error && lastPage > 1" class="d-flex justify-content-center py-3"><PaginationList v-bind="paginationSettings" /></div>
  </section>
</template>
<script>
import { getStoreMailOrders } from '@/api/orders'
import dayjs from 'dayjs'
import OrderHistoryTable from '@/components/order/OrderHistoryTable.vue'
import { orderPagination } from '@/utils/orderPagination'
export default {
  components: { OrderHistoryTable },
  computed: {
    columns() { return [{ key: 'order_number', label: '訂單編號' }, { key: 'ordered_at', label: '下單時間' }, { key: 'total_price', label: '訂單金額' }, { key: 'total_pv', label: '訂單積分' }, { key: 'tracking', label: '配送進度' }, { key: 'invoice_number', label: '發票號碼' }] },
    paginationSettings() { return orderPagination(this.page, this.lastPage, this.load) }
  },
  data: () => ({ orders: [], page: 1, lastPage: 1, loading: true, error: '', requestId: 0 }),
  created() { this.load(1) },
  beforeDestroy() { this.requestId++ },
  methods: {
    formatCell(row, key) {
      if (key === 'ordered_at') return this.formatTime(row.ordered_at)
      if (key === 'total_price') return this.value(row.total_price, true)
      if (key === 'total_pv') return this.value(row.total_pv)
      if (key === 'tracking') return this.status(row)
      return row[key] || '尚未提供'
    },
    value(v, money = false) { return v === null || v === undefined ? '尚未提供' : (money ? 'NT ' : '') + Number(v).toLocaleString('zh-TW') },
    formatTime(value) { return value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '尚未提供' },
    status(order) { return (order.shipments || []).map(s => s.latest_status_text || '物流資料準備中').filter((v, i, a) => a.indexOf(v) === i).join('／') || '尚無貨態' },
    async load(page) {
      const id = ++this.requestId
      this.loading = true; this.error = ''; this.orders = []
      try {
        const res = await getStoreMailOrders({ page })
        if (id !== this.requestId) return
        this.orders = res.data.data; this.page = res.data.current_page; this.lastPage = res.data.last_page
      } catch (e) {
        if (id === this.requestId) this.error = '無法載入營業所郵寄訂單，請確認登入狀態及貨態查詢權限。'
      } finally { if (id === this.requestId) this.loading = false }
    }
  }
}
</script>
